import { raise, } from "./raise";
import type { EpochMilliseconds, EpochSeconds, ISOTimeString, } from "@bracket/types";
import { isEpochMilliseconds, isEpochSeconds, isISOTimeString, } from "@bracket/types";
import { DateTime, } from "luxon";

/**
 * Converts a variety of date/time representations to a Luxon DateTime object.
 *
 * Accepts:
 *   - Date (JS Date instance)
 *   - ISOTimeString (ISO 8601 string)
 *   - EpochMilliseconds (number, ms since epoch)
 *   - EpochSeconds (number, s since epoch)
 *
 * @param datetime The date/time representation to convert.
 * @returns DateTime The corresponding Luxon DateTime object.
 * @throws If `datetime` is not a recognized date/time type.
 */
export const getDateTime = (
	datetime: Date | ISOTimeString | EpochMilliseconds | EpochSeconds | DateTime,
): DateTime => {
	return (
		datetime instanceof Date ? DateTime.fromJSDate(datetime) :
		datetime instanceof DateTime ? datetime :
		isISOTimeString(datetime) ? DateTime.fromISO(datetime) :
		isEpochSeconds(datetime) ? DateTime.fromSeconds(datetime) :
		isEpochMilliseconds(datetime) ? DateTime.fromMillis(datetime) :
		raise(`@bracket/parlance/getDateTime: invalid datetime provided: ${datetime}`)
	);
}
